module.exports = __webpack_public_path__ + "static/img/icon_zyzpx.86c52b16.png";